import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import { CookieStorage } from "redux-persist-cookie-storage";
import Cookies from "js-cookie";
import authentication from "./authentication";
import cookie from "./cookie";
import printer from "./printer";
import errors from "./errors";
import configReducer from "./config";
import productReducer from "./product";
import menuItemsReducer from "./menu-items";
import lineItemsReducer from "./line-items";
import optionsReducer from "./options";
import orderReducer from "./order";
import { SESSION_COOKIE_TIMEOUT } from "../constants/user";

const cookieStorage = new CookieStorage(Cookies, {
  setCookieOptions: {
    path: "/",
    expires: new Date(new Date().getTime() + SESSION_COOKIE_TIMEOUT),
  },
});

export const cookiePersistConfig = {
  key: "cookie",
  storage: cookieStorage,
  whitelist: ["registerUserToken"],
};

const cookieReducer = persistReducer(cookiePersistConfig, cookie);

const rootReducer = combineReducers({
  authentication,
  cookie: cookieReducer,
  printer,
  errors,
  configState: configReducer,
  productState: productReducer,
  menuItems: menuItemsReducer,
  lineItems: lineItemsReducer,
  itemOptions: optionsReducer,
  orders: orderReducer,
});

type RootState = ReturnType<typeof rootReducer>;

export type { RootState };
export default rootReducer;
